<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Опросы </span>
        <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
          color="var(--app-dark-blue-1)">mdi-information</v-icon>
      </div>
      <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
        <v-card min-width="300px" min-height="100px">
          <div class="menu-container">
            <div class="menu-container-title">Опросы</div>
            <div class="menu-container-text">
              Раздел мобильного приложения, в котором отображаются опросы из
              этого списка. Опросы могут быть с правильным ответом или не иметь
              верного вообще
            </div>
            <div class="menu-container-title">
              Иконка
              <v-icon small color="#929292"> mdi-arrow-collapse-down </v-icon>
            </div>
            <div class="menu-container-text">
              Скачать подробную статистику опроса (информация о пользователях,
              которые голосовали и какие варианты ответов выбрали)
            </div>
            <div class="menu-container-title">
              Иконка
              <v-icon small color="#929292"> mdi-bell </v-icon>
            </div>
            <div class="menu-container-text">
              Была рассылка push-уведомлений при публикации опроса
            </div>
            <div class="menu-container-title">
              Иконка
              <v-icon small color="#929292"> mdi-check-circle </v-icon>
            </div>
            <div class="menu-container-text">
              Опрос активен, можно голосовать (не видно результаты в приложении,
              если пусто - опрос завершен - в приложении можно видеть
              результаты.
            </div>
          </div>
        </v-card>
      </v-menu>
      <v-spacer></v-spacer>

      <v-btn @click="goToCreate" style="width: auto !important" class="button-accept">
        + Добавить опрос
      </v-btn>
    </div>
    <div>
      <div class="table-container">
        <v-data-table :headers="headers" :items="items" class="elevation-0 main-table" :disable-pagination="true"
          :hide-default-footer="true" :hide-default-header="true" fixed-header>
          <template v-slot:header>
            <thead>
              <tr>
                <th v-for="(s, index) in headers" :key="index">
                  <div style="margin-left: 24px" v-if="s.value == 'dateCreated' || s.value == 'dateEnd'">
                    {{ s.text }}
                  </div>
                  <div v-else>
                    {{ s.text }}
                  </div>
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:body>
            <tbody>
              <tr v-for="(item, index) in items" :key="index">
                <td @click="goToDetail(item)">
                  {{ item.title }}
                </td>
                <td @click="goToDetail(item)">
                  {{ item.countAnswers }}
                </td>
                <td @click="goToDetail(item)">
                  <div class="d-flex align-center" v-if="item.toSendPush">
                    <v-icon small> mdi-bell </v-icon>
                    <div style="margin-left: 8px">
                      {{ item.dateCreated | moment("DD.MM.YYYY HH:mm") }}
                    </div>
                  </div>
                  <div class="d-flex align-center" v-else>
                    <div style="width: 24px"></div>
                    <div>
                      {{ item.dateCreated | moment("DD.MM.YYYY HH:mm") }}
                    </div>
                  </div>
                </td>
                <td @click="goToDetail(item)">
                  <div class="d-flex align-center" v-if="item.dateEnd && checkdate(item.dateEnd)">
                    <v-icon small color="var(--app-green-1)"> mdi-check-circle </v-icon>
                    <div style="margin-left: 8px">
                      {{ item.dateEnd | moment("DD.MM.YYYY HH:mm") }}
                    </div>
                  </div>
                  <div class="d-flex align-center" v-else>
                    <div style="width: 24px"></div>
                    <div>
                      {{ item.dateEnd | moment("DD.MM.YYYY HH:mm") }}
                    </div>
                  </div>
                </td>
                <td class="d-flex justify-end align-center">
                  <div style="cursor: pointer" @click="downloadFile(item)">
                    <v-icon size="20">mdi-arrow-collapse-down</v-icon>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>

import FileSaver from "file-saver";

export default {
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    items: [],
    dateTable: null,

    headers: [
      {
        text: "Название",
        sortable: false,
        value: "title",
        align: "left",
      },
      {
        text: "Кол-во ответов",
        sortable: false,
        value: "countAnswers",
        align: "left",
      },
      {
        text: "Дата создания",
        sortable: false,
        value: "dateCreated",
        align: "left",
      },
      {
        text: "Дата завершения",
        sortable: false,
        value: "dateEnd",
        align: "left",
      },
      {
        text: "",
        sortable: false,
        value: "download",
        align: "rigth",
        width: "150px",
      },
    ],
  }),
  watch: {},
  methods: {
    openInfo(e) {
      e.preventDefault();

      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
      this.showInfo = true;
    },
    goToDetail(item) {
      this.$router.push({ name: "PollDetail", params: { id: item.id } });
    },
    goToCreate() {
      this.$router.push({ name: "PollCreate" });
    },

    getItems() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV3 + "/poll/list",

          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.items.forEach((element) => {
            let count = 0;
            element.answers.forEach((el) => {
              count = count + el.numberOfVoters;
            });
            element.countAnswers = count;
          });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    downloadFile(item) {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV3 + "/poll/statistics/download",
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
            params: {
              pollId: item.id,
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          FileSaver.saveAs(res.data, `${item.title}.xlsx`);
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    checkdate(date) {
      const nowDate = new Date().getTime();
      return date > nowDate;
    },
  },
  created() {
    this.getItems();
  },
};
</script>
<style lang="scss" scoped>
.table-container {
  height: calc(100vh - 190px);

  .main-table {
    height: calc(100vh - 190px) !important;
    min-height: calc(100vh - 190px) !important;
    max-height: calc(100vh - 190px) !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>